const State = {

    // FIELDS
    "state": "State",
    "name": "Name",
    "description": "Description",
    "country": "Country",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "State",
    "filter_title": "State Filter",
    "add_title": "Add State",
    "update_title": "Update State",
    // TABLE HEADER
    "table_name": "Name",
    "table_country": "Country",
    "table_description": "Description",
    "table_status": "Status",
    
    // ERROR
    "error_name": "Enter State Name",
    "error_description": "Enter Description",
    "error_country": "Select Country",
    "error_status": "Select Status",

}

export default State;

